/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface VideoInput
 */
export interface VideoInput {
  /**
   *
   * @type {number}
   * @memberof VideoInput
   */
  position: number;
  /**
   *
   * @type {string}
   * @memberof VideoInput
   */
  vimeoLabel: string;
  /**
   *
   * @type {string}
   * @memberof VideoInput
   */
  vimeoLink: string;
}

export function VideoInputFromJSON(json: any): VideoInput {
  return VideoInputFromJSONTyped(json, false);
}

export function VideoInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): VideoInput {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    position: json["position"],
    vimeoLabel: json["vimeoLabel"],
    vimeoLink: json["vimeoLink"],
  };
}

export function VideoInputToJSON(value?: VideoInput | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    position: value.position,
    vimeoLabel: value.vimeoLabel,
    vimeoLink: value.vimeoLink,
  };
}
